// btw-front/src/api/adminCompanyDataset.js
// 고객사 검색 데이터셋(국민연금 월별) 활성 포인터 — 상태 조회 / 즉시 갱신.
import { api } from "./client";

// 현재 활성 데이터셋 상태 — { yearMonth, datasetUuid, rowCount, refreshAt, lastRunOn, lastCheckedAt, resolvedAt, pinned }
export async function getStatus() {
  return api.get(`/admin/company-dataset`);
}

// 즉시(수동) 갱신 — { changed, reason, currentYm, latestYm?, candidateCount? }
export async function refresh() {
  return api.post(`/admin/company-dataset/refresh`, {});
}
